export default "__VITE_ASSET__C9y5JhZd__"